import { api, apiCall } from './client'
import type { ApiResponse } from '../../types'
import type { AuthResponse } from './auth'

export const pscAuthService = {
  async getAuthorizationUrl(): Promise<
    ApiResponse<{ authorizationUrl: string; state: string }>
  > {
    return apiCall(
      api.get<ApiResponse<{ authorizationUrl: string; state: string }>>(
        '/auth/psc'
      )
    )
  },

  // Échange le code temporaire (reçu via l'URL de callback) contre les vrais tokens
  async exchangeCode(code: string): Promise<ApiResponse<AuthResponse>> {
    return apiCall(api.post<ApiResponse<AuthResponse>>('/auth/psc/exchange', { code }))
  },
}
